import axios from "axios";
import { cookieAxios } from "../interceptors/cookieAxios";

class StateService {
  getStateById = (id) => {
    return axios({
      method: "post",
      url: `/users/get-state`,
      data: id,
      headers: {
        "content-type": "multipart/form-data",
      },
    })
      .then((response) => {
        return response.data;
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  getAllPinCode = (pincode) => {
    return axios({
      method: "get", // API expects GET
      url: `/users/api/pincode/${pincode}/`, // Dynamically inject pincode
      headers: {
        "Content-Type": "application/json",
      },
    })
      .then((response) => response.data)
      .catch((error) => console.log(error));
  };

  getAllState = () => {
    return axios({
      method: "post",
      url: `/users/get-all-state`,
      headers: {
        "Content-Type": "application/json",
      },
    })
      .then((response) => {
        return response.data;
      })
      .catch(function (error) {
        console.log(error);
      });
  };
  CreateState = (formdata) => {
    return axios({
      method: "post",
      url: `/users/create-state`,
      data: formdata,
      headers: {},
    })
      .then((response) => {
        return response.data;
      })
      .catch(function (error) {
        console.log(error);
      });
  };
  EditState = (formdata) => {
    return axios({
      method: "post",
      url: `/users/edit-state`,
      data: formdata,
      headers: {
        "content-type": "multipart/form-data",
      },
    })
      .then((response) => {
        return response.data;
      })
      .catch(function (error) {
        console.log(error);
      });
  };
  DeleteState = (formdata) => {
    return axios({
      method: "post",
      url: `/users/delete-state`,
      data: formdata,
      headers: {
        "content-type": "multipart/form-data",
      },
    })
      .then((response) => {
        return response.data;
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  AddStateHead = (formdata) => {
    return axios({
      method: "post",
      url: `/users/add-state-head`,
      data: formdata,
      headers: {
        "content-type": "multipart/form-data",
      },
    })
      .then((response) => {
        return response.data;
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  DeleteStateHead = (formdata) => {
    return axios({
      method: "post",
      url: `/users/delete-state-head`,
      data: formdata,
      headers: {
        "content-type": "multipart/form-data",
      },
    })
      .then((response) => {
        return response.data;
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  getUserStatePermissions = (formdata) => {
    return cookieAxios({
      method: "post",
      url: `/auctions/get-user-state-permissions`,
      data: formdata,
      headers: {
        "content-type": "multipart/form-data",
      },
    })
      .then((response) => {
        return response.data;
      })
      .catch(function (error) {
        console.log(error);
      });
  };
}

export default new StateService();
